var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80237 14.1667H16.6667V4.16667H3.33335V15.3209L4.80237 14.1667ZM5.37881 15.8333L1.66669 18.75V3.33333C1.66669 2.8731 2.03979 2.5 2.50002 2.5H17.5C17.9603 2.5 18.3334 2.8731 18.3334 3.33333V15C18.3334 15.4602 17.9603 15.8333 17.5 15.8333H5.37881ZM9.16669 11.6667H10.8334V13.3333H9.16669V11.6667ZM7.13945 7.34455C7.40533 6.00766 8.58502 5 10 5C11.6109 5 12.9167 6.30583 12.9167 7.91667C12.9167 9.5275 11.6109 10.8333 10 10.8333H9.16669V9.16667H10C10.6904 9.16667 11.25 8.607 11.25 7.91667C11.25 7.22631 10.6904 6.66667 10 6.66667C9.3936 6.66667 8.88802 7.09852 8.77402 7.67147L7.13945 7.34455Z",
    fill: "#2F3444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickChat);
export default __webpack_public_path__ + "static/media/quick-chat.a71952268c80f91752ecb9a132585b25.svg";
export { ForwardRef as ReactComponent };